import React from 'react';

export default function GameToolbar({ games, players, selectedKey, onSelectGame, award, onAwardChange, config, configSchema, onConfigChange, phase, loading, actions, isHost }) {
  // Simplified gating: only enable host controls while in lobby
  const isNotLobby = phase !== 'lobby';

  // --- CONFIG OVERRIDE: Number of Rounds is always 5 and hidden from UI ---
  // If you want to change the default, update the value below and the backend logic in WhoIsPayingRoom.jsx
  const configOverride = { ...config };
  if ('Number_of_rounds' in configOverride) {
    configOverride['Number_of_rounds'] = 5;
  }

  return (
    <section className="block-lobby-card section-host-panel">
      <div className="block-host-group">
        <label className="block-host-label">Pick a Game</label>
        <div className="block-host-game-select">
          {games.map((g) => (
            <button key={g.key} type="button" onClick={() => onSelectGame && onSelectGame(g.key)} disabled={isNotLobby || !isHost || loading} className={selectedKey === g.key ? 'block-entry-choice is-active' : 'block-entry-choice'}>
              <span aria-hidden>{g.icon}</span> {g.name}
            </button>
          ))}
        </div>
      </div>

      {/*
        Number of Rounds config is always set to 5 and hidden from UI.
        To change, update configOverride['Number_of_rounds'] above and backend logic in WhoIsPayingRoom.jsx.
      */}

      <div className="block-results-actions">
        <button
          type="button"
          className="control-view-rules"
          onClick={actions?.lock}
          disabled={isNotLobby || !isHost || loading || !selectedKey || (Array.isArray(players) ? players.length < 2 : true)}
        >Lock</button>
        <button type="button" className="control-view-rules" onClick={actions?.start} disabled={!isHost || loading || phase !== 'locked'}>Start</button>
      </div>
    </section>
  );
}
